import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsSpeed() {
  const descriptionList = [
    "Votre ordinateur est devenu lent avec le temps ? Cette prestation permet d'optimiser ses performances pour qu'il retrouve fluidité et réactivité.",
    "Ce service inclut la mise à jour du système et des pilotes, l'optimisation des paramètres, ainsi que le nettoyage des logiciels inutiles.",
  ];
  const deroulementList = [
    "1 Prise de rendez vous : Nous convenons d'un rendez vous à notre atelier avec votre ordinateur ou directement à votre domicile.",
    "2 Diagnostic de l'état du système : Vérification des lenteurs et des causes possibles (logiciels, disque dur, surchauffe…).",
    "3 Mises à jour essentielles : Installation des dernières mises à jour du système d'exploitation et des pilotes pour garantir stabilité et compatibilité.",
    "4 Optimisation des paramètres : Réglages avancés pour améliorer la réactivité du système (démarrage rapide, gestion de la mémoire, désactivation des processus inutiles…).",
    "5 Désinstallation des programmes inutiles : Suppression des logiciels superflus et des bloatwares qui ralentissent l'ordinateur.",
    "6 Nettoyage et défragmentation : Suppression des fichiers temporaires et optimisation du disque dur pour libérer de l'espace.",
    "7 Tests et restitution : Vérification des performances avant de vous contacter pour la récupération de votre appareil si vous l'aviez déposé à l'atelier.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="ACCÉLÉRATION DU SYSTÈME"
        price="40€ TTC"
        atelier={true}
        domicile={true}
        time="2h - 4h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="" />
    </div>
  );
}

export default TarifsSpeed;
